import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetReducer(state = initialState.budgetContent, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETCONTENT_SUCCESS:
      return action.budgetContent;
    default:
      return state;
  }
}
